// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth  } from "firebase/auth";
import { getFirestore}  from "firebase/firestore"; 

const firebaseConfig = {
  apiKey: "AIzaSyDCENsh0tZlNtbcNAZZHqt1RtkNIsWsNuE",
  authDomain: "monmarhe.firebaseapp.com",
  projectId: "monmarhe",
  storageBucket: "monmarhe.appspot.com",
  messagingSenderId: "810364309186",
  appId: "1:810364309186:web:da08e91684ffd2eadb755b",
  measurementId: "G-Y79EEFBYML"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth()


// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);